import React from 'react';
import { Route, Switch } from 'react-router-dom';
import VariantOptionList from '../Pages/VariantOptions/VariantOptionList';
import VariantOptionAdd from '../Pages/VariantOptions/VariantOptionAdd';
import VariantOptionEdit from '../Pages/VariantOptions/VariantOptionEdit';
import VariantOptionView from '../Pages/VariantOptions/VariantOptionView';

/**
 * Routes for variant option CRUD operations
 * @param {Object} props - Component props
 * @returns {JSX.Element} VariantOptionRoutes component
 */
const VariantOptionRoutes = (props) => {
  const { match } = props;
  const { path } = match;
  
  return (
    <Switch>
      <Route exact path={`${path}`} component={VariantOptionList} />
      <Route exact path={`${path}/add`} component={VariantOptionAdd} />
      <Route exact path={`${path}/edit/:slack`} component={VariantOptionEdit} />
      <Route exact path={`${path}/view/:slack`} component={VariantOptionView} />
    </Switch>
  );
};

export default VariantOptionRoutes;
